import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

const DISMISS_KEY = "seopilot_verify_banner_dismissed_until";

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try {
      const t = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
      return t && Date.now() < t;
    } catch (e) { return false; }
  });

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification", { origin_url: window.location.origin });
      toast.success("Verification email re-sent");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Couldn't resend");
    }
    setBusy(false);
  };

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now() + 6 * 3600 * 1000)); } catch (e) { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div className="border-b border-amber-300 bg-amber-50" data-testid="verify-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2 flex items-center justify-between gap-3 flex-wrap text-amber-900">
        <div className="flex items-center gap-2 text-sm">
          <Mail className="w-4 h-4" />
          <span className="font-mono-data text-[11px] uppercase tracking-widest">verify email</span>
          <span>Confirm <strong className="font-mono-data">{user.email}</strong> so we can send receipts &amp; post reminders.</span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <button onClick={resend} disabled={busy} className="border border-amber-700 px-3 py-1.5 font-mono-data uppercase tracking-widest hover:bg-amber-100 disabled:opacity-60" data-testid="verify-banner-resend">
            {busy ? "Sending…" : "Resend"}
          </button>
          <button onClick={dismiss} className="opacity-70 hover:opacity-100 px-2 py-1 font-mono-data uppercase tracking-widest" data-testid="verify-banner-dismiss">
            later
          </button>
        </div>
      </div>
    </div>
  );
}
